import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { AfFlag } from "../model/af.model";
import { AuthService } from '../service/auth.service';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  afFlag: AfFlag;
  @Output() navigationUpdated: EventEmitter<any> = new EventEmitter();
  constructor(private httpClient: HttpClient , private userService: AuthService) { }

 

}
